import React from "react";
import { ModalComponent } from "../../../components/Modal.components";
import { PageTitle } from "../../../components/style";
import { Boxed } from "../../../components/Boxed.components";
import { Button } from "../../../components/Button.components";
import { Text } from "../../../components/Text.components";

export const ResetModal = (props) => {
  console.log(props);

  // State props
  const { resetModal, userData } = props;
  // Dispatch props
  const { closeModal, resetUserPassword } = props;
  return (
    <ModalComponent
      show={resetModal}
      onHide={closeModal}
      title={<PageTitle margin="5px 0">{props.label}</PageTitle>}
      footer={
        <Boxed display="flex" width="100%">
          <Button clear onClick={closeModal}>
            Cancel
          </Button>
          <Button
            margin="0 0 0 auto"
            // progress={isLoading}
            // disabled={isLoading}
            // onClick={onSubmit}
            onClick={() => resetUserPassword(userData.email)}
          >
            {props.label}
          </Button>
        </Boxed>
      }
    >
      <Boxed>
        <Text>
          A link will be sent to the email associated with this account
        </Text>
      </Boxed>
    </ModalComponent>
  );
};
